import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem, getResetByTag, breakpoints } from '../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var isSlideDrawer = _ref.isSlideDrawer;
  return /*#__PURE__*/css("border-radius:inherit;display:flex;flex-direction:column;max-height:", isSlideDrawer ? '100%' : "calc(90vh - ".concat(rem(50), ")"), ";width:100%;@media (max-width: ", rem(breakpoints.md[0]), "){max-height:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledModalContentContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1ezewfm0"
} : {
  target: "e1ezewfm0",
  label: "StyledModalContentContainer"
})(resetStyles, defaultStyles);
export default StyledModalContentContainer;